import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { storyline } from '@/mocks/drama';

export default function Storyline() {
  return (
    <section id="storyline" className="scroll-mt-32 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="剧情脉络"
            title="从毒品迷局到决斗代价"
            desc="以曼婷与恩诚为核心的这条主线，把全剧的紧张感推到极致。以下按时间顺序梳理主要节点，帮助你快速理清剧情走向。"
          />
        </Reveal>

        <div className="relative mt-12 pl-2">
          <span className="absolute bottom-2 left-[27px] top-2 w-[2px] bg-background-300 md:left-[31px]" />
          <div className="space-y-4">
            {storyline.map((node, index) => (
              <Reveal key={node.step} delay={index * 60}>
                <div className="relative flex gap-5">
                  <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full border-2 border-background-50 bg-primary-500 font-heading text-sm font-bold text-background-50 md:h-14 md:w-14 md:text-base">
                    {node.step}
                  </span>
                  <div className="flex-1 rounded-lg border border-background-200 bg-background-100/60 p-4 md:p-5">
                    <h3 className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                      {node.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-700">{node.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}